import { FunctionsHttpError } from '@supabase/supabase-js';

export async function extractErrorMessage(err: unknown): Promise<string> {
  if (err instanceof FunctionsHttpError) {
    try {
      const body = await err.context.json();
      if (body?.error) return String(body.error);
      if (body?.message) return String(body.message);
    } catch {
      try {
        const text = await err.context.text();
        if (text) return text.slice(0, 500);
      } catch {
        // ignora
      }
    }
  }
  return (err as Error)?.message || 'Erro na função do servidor.';
}